const Time = () => (
  <>
    <path
      fill="currentColor"
      d="M12.5 11.792V7.5a.48.48 0 0 0-.144-.356.49.49 0 0 0-.357-.144.48.48 0 0 0-.356.144.49.49 0 0 0-.143.356v4.379q0 .152.056.297a.8.8 0 0 0 .186.274l2.843 2.843a.5.5 0 0 0 .344.15.47.47 0 0 0 .364-.15.5.5 0 0 0 .16-.354.5.5 0 0 0-.16-.354z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
      clipRule="evenodd"
    />
  </>
)
export default Time
